import { ApmRoute } from '@elastic/apm-rum-react';
import React, { Suspense } from 'react';
import { Redirect, Switch } from '@interhyp/platform-router';

import { usePaths } from './hooks/usePaths';

export function Router() {
  const routePaths = usePaths();
  return (
    <Suspense fallback={null}>
      <Switch>
        <ApmRoute path="/sales/configurator" component={() => <Redirect to="/konfiguration" />} />

        {routePaths.map(route => (
          <ApmRoute {...route} key={route?.path} />
        ))}
        <ApmRoute path="/" exact component={() => <Redirect to="/start" />} />
      </Switch>
    </Suspense>
  );
}
